/**
 * Inbound phone numbers for different countries.
 * Each entry includes the country name, flag emoji, display format, and E.164 format.
 */
export const INBOUND_PHONE_NUMBERS = [
  { country: "Australia", flag: "🇦🇺", display: "+61 468 051 111", e164: "+61468051111" },
  { country: "United States", flag: "🇺🇸", display: "+1 (218) 318 2545", e164: "+12183182545" },
];
